// src/common/security/fingerprint.js
// Basit fingerprint; hem named hem default export.

function hash(str) {
  let h = 0;
  for (let i = 0; i < str.length; i++) h = (h << 5) - h + str.charCodeAt(i) | 0;
  return ("00000000" + (h >>> 0).toString(16)).slice(-8);
}

export function getFingerprint() {
  try {
    const nav = window.navigator || {};
    const scr = window.screen || {};
    const parts = [
      nav.userAgent || "-",
      nav.language || "-",
      scr.width || "-", scr.height || "-",
      scr.colorDepth || "-",
      Intl.DateTimeFormat().resolvedOptions().timeZone || "-",
      nav.platform || "-",
      nav.hardwareConcurrency || "-",
      nav.deviceMemory || "-",
    ].join("|");
    return "fp_" + hash(parts);
  } catch {
    return "fp_" + hash(String(Math.random()));
  }
}

export default getFingerprint;
